import moment from "moment";
import { PlanSlugs, Subs, SubsItem } from "../@types";
import { SubsResponse } from "../@types";

const subsStatus: Record<string, string> = {
  active: "Assinante",
  trialing: "Período de teste",
  past_due: "Em atraso",
  incomplete: "Erro ao realizar pagamento",
};

const periodLabel: Record<string, string> = {
  month: "Mensal",
  semester: "Sementral",
  year: "Anual",
};

export class SubsMapper {
  static toDomain(response: SubsResponse): Subs {
    const is_trial = !!(response.status === "canceled" && response.trial_end);

    const is_active = !["incomplete_expired", "canceled", "unpaid"].includes(
      response.status,
    );

    const has_canceled = !!response.cancel_at;

    const subscribe_enabled =
      ["incomplete_expired", "canceled", "unpaid"].includes(response.status) ||
      response.plan.slug === PlanSlugs.basic;

    const manual_payment_enabled = ["past_due", "incomplete"].includes(
      response.status,
    );

    // Assinatura dada pelo admin
    const is_manual = response.plan.gateway === "manual";

    const update_credit_card_enabled =
      (!is_manual || manual_payment_enabled) && is_active;

    const cancel_enabled = !has_canceled && !is_trial && !is_manual;

    let status = {
      text: subsStatus[response.status],
      color: "primary",
    };

    let cancellation_date = "";
    if (has_canceled) {
      cancellation_date = moment(response.cancel_at).format(
        "DD[ de ]MMMM[ de ]YYYY",
      );
    }

    let credit_card_last4 = "";
    if (response.card_info) {
      credit_card_last4 = `•••• •••• •••• ${response.card_info?.last4}`;
    }

    let trial_end_date = "";
    if (response.trial_end) {
      trial_end_date = moment(response.trial_end).format(
        "DD[ de ]MMMM[ de ]YYYY",
      );
    }

    let current_plan_description = null;
    if (is_trial) {
      current_plan_description = {
        text: `Você está no período de avaliação do plano atual até a data de ${trial_end_date}. Após esta data você perderá acesso ao aplicativo.`,
        color: "primary",
      };
    }
    if (is_manual) {
      current_plan_description = {
        text: `Sua assinatura foi realizada pelo administrador. Para gerenciar sua conta, entre em contato com o suporte.`,
        color: "primary",
      };
    }

    let status_description = null;
    if (has_canceled && is_active) {
      status_description = {
        text: `Você cancelou a assinatura e poderá usar o aplicativo até o dia ${cancellation_date}. Após esta data você perderá acesso ao aplicativo.`,
        color: "danger",
      };

      status.text = "Cancelado";
      status.color = "danger";
    }

    let items: SubsItem[] = [
      {
        key: "current_plan",
        label: "Plano atual",
        value: { text: response.plan.title, color: "primary" },
        description: current_plan_description,
      },
    ];

    if (is_active && !is_manual) {
      items = [
        ...items,
        {
          key: "status",
          label: "Status",
          value: status,
          description: status_description,
        },
        {
          key: "period",
          label: "Período",
          value: {
            text: periodLabel[response.price.frequency],
            color: "primary",
          },
        },
        {
          key: "created_at",
          label: "Desde",
          value: {
            text: moment(response.created_at).format("DD/MM/YYYY"),
            color: "primary",
          },
        },
        {
          key: "renewal",
          label: "Renovação",
          value: {
            text: moment(response.current_period_end).format("DD/MM/YYYY"),
            color: "primary",
          },
        },
        {
          key: "credit_card",
          label: "Cartão",
          value: { text: credit_card_last4, color: "primary" },
        },
      ];
    }

    return {
      id: response.id,
      plan_title: response.plan.title,
      has_canceled,
      subscribe_enabled,
      manual_payment_enabled,
      cancel_enabled,
      update_credit_card_enabled,
      items,
    };
  }
}
